import { Observable } from "rxjs";
import { RespInterface } from "@common/ports/interfaces/respt.interface";
import { RespListInterface, UserAddressInterface, UserInterface } from "@common/ports/interfaces";
import { ProfileInterface } from "../interfaces";

export abstract class UserAbstraction {
  abstract list(query: string): Observable<RespListInterface<UserInterface>>;
  abstract listUserAddress(query: string): Observable<RespListInterface<UserAddressInterface>>;
  abstract create(user: UserInterface): Observable<RespInterface<UserInterface>>;
  abstract createUserAddress(user: UserAddressInterface): Observable<RespInterface<UserAddressInterface>>;
  abstract read(id: string): Observable<RespInterface<UserInterface>>;
  abstract readAddress(id: string): Observable<RespInterface<UserAddressInterface>>;
  abstract profileGet(): Observable<RespInterface<UserInterface>>;
  abstract update(user: UserInterface): Observable<RespInterface<string>>;
  abstract updateMasive(user: { ids: string[], isActive: boolean }): Observable<RespInterface<string>>;
  abstract updateAddress(user: UserAddressInterface): Observable<RespInterface<string>>;
  abstract profileUpdate(user: ProfileInterface): Observable<RespInterface<ProfileInterface>>;
  abstract delete(id: string): Observable<RespInterface<UserInterface>>;
  abstract deleteAddress(id: string, userId: string): Observable<RespInterface<UserAddressInterface>>;
}
